import { Theme } from '@radix-ui/themes';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { appRouter } from '@/app/appRouter';

import '@/shared/base.css';
import '@radix-ui/themes/styles.css';
import { appStore } from '@/app/appStore';
import { DashProvider } from '@/app/context/dash-context';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Theme>
      <Provider store={appStore}>
        <DashProvider>
          <RouterProvider router={appRouter()} />
        </DashProvider>
      </Provider>
      <Toaster />
    </Theme>
  </React.StrictMode>
);
